enum PropertyTypeEnum {
    Commercial = 'COMMERCIAL',
    Residential = 'RESIDENTIAL',
    Rural = 'RURAL',
}

export default PropertyTypeEnum;
